import { DashboardResponse } from '@com-delta-idp/mnx-oauth';
import { VALID_MEMBERSHIP_LEVELS } from '../models/sky-club.constants';

export const validateUser = (user: Partial<DashboardResponse>): boolean => {
  return (user.loggedIn && validUser(user.membershipLevel ?? '')) ?? false;
};

const validUser = (membershipLevel: string) => {
  return VALID_MEMBERSHIP_LEVELS.includes(membershipLevel);
};
